import ElementNotifications from './ElementNotifications';

export default {
  elementNotifications: [ 'type', ElementNotifications ]
};